/* eslint-disable @nx/enforce-module-boundaries */
import { useTranslation } from '@axo/shared/i18n';
import { Stack } from '@axo/ui-core/components/layout/item';
import { Text } from '@axo/ui-core/components/typography';
import { useAxoFormContext } from '../../../context/AxoForm/AxoForm';
import styles from './ESkat.module.scss';
import { useESkat } from './hooks/useESkat';
import { getESkatDetailsDisplayValues } from './utils';

type ESkatInfoProps = {
  kind: 'loan' | 'person';
};
export const ESkatInfo = ({ kind }: ESkatInfoProps) => {
  const { t } = useTranslation();

  const { eSkatData } = useESkat();

  const { axoFormData } = useAxoFormContext();

  if (!eSkatData) return null;

  const { UpdatedLoanFields, UpdatedPersonFields } = eSkatData;

  const title =
    kind === 'loan'
      ? t('ESkat.success_modal.title_loan')
      : t('ESkat.success_modal.title_person');

  const fields = kind === 'loan' ? UpdatedLoanFields : UpdatedPersonFields;
  const fieldName = kind === 'loan' ? 'LoanApplication' : 'Person';

  return (
    <Stack gap="3xs">
      <Text size="l">
        <b>{title}</b>
      </Text>

      <Stack gap="3xs" className={styles.detailsInfo}>
        {fields?.map((field, index) => {
          // LoanApplication/Debts displayed on a separated component DebtInfo
          if (field === 'Debts') return null;

          const value = axoFormData[`${fieldName}/${field}`];

          if (value === null || value === undefined) return null;

          const { title, displayValue } = getESkatDetailsDisplayValues({
            field,
            value,
            t,
          });

          return (
            <Stack key={index} direction="h">
              <Text>{title}</Text>
              <Text className={styles.textEnd}>{displayValue}</Text>
            </Stack>
          );
        })}
      </Stack>
    </Stack>
  );
};
